import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    tag: {
        padding: '.3rem .6rem',
        borderRadius: '.4rem',
        background: defaultPalette.lightGrey.half,
        width: 'fit-content',
    },
    tagRounded: {
        padding: '.375rem .75rem .375rem .375rem',
        borderRadius: '100px',
    },
    tagLabel: {
        color: defaultPalette.red.main,
        fontSize: '.9rem',
    },
})
